import * as tool from "./_tools";
function accessibility() {
    tool.waitForElem(".pojo-a11y-toolbar-link").then((r) => {
        //selectionne l'enfant svg de r
        let accessibility = r.querySelector("svg");
        //on change les attributs de l'enfant svg
        accessibility.setAttribute("width", "3rem");
        accessibility.setAttribute("viewBox", "0 0 1162.2 1162.2");
        accessibility.setAttribute(
            "style",
            "enable-background:new 0 0 1162.2 1162.2;"
        );
        accessibility.setAttribute("xml:space", "preserve");
        accessibility.setAttribute("aria-hidden", "true");
        accessibility.setAttribute("x", "0px");
        accessibility.setAttribute("y", "0px");
        //remplace le g par un autre
        accessibility.querySelector("g").innerHTML = "";
        //ajoute le nouveau g
        accessibility.querySelector("g").innerHTML =
            '<path d="M991,577.4l-0.4-0.6c-1.6-2.4-40.3-60.3-109.8-117.9c-41-34-84.4-60.8-129-79.8c-56-23.9-114-35.4-172.2-34.1c-58.3-1.3-116.2,10.2-172.2,34.1c-44.6,19-88,45.9-129,79.8c-69.6,57.6-108.2,115.5-109.8,117.9l-0.4,0.6c-6.6,10.5-6.4,24.3,0.4,34.6v0c1.6,2.4,40.3,60.3,109.8,117.9c41,34,84.5,60.8,129,79.8c56,23.9,114,35.4,172.2,34.1c3,0.1,5.9,0.1,8.9,0.1c147.3,0,261-80.5,330.9-148.8c23.7-23.1,41.6-44.3,52.5-58c5-6.3,9.6-12.4,13.7-18.1c2-2.7,3.6-5,4.9-7.1l0,0C997.5,601.7,997.6,587.9,991,577.4z M849.1,693.8c-37.4,30.8-76.7,55.1-116.9,72.1c-49.6,21.1-100.8,31.1-152.1,29.9l-0.6,0l-0.6,0C527.7,797,476.6,787,427,766c-40.2-17-79.5-41.3-116.9-72.1c-49.1-40.4-82.1-81.8-95.2-99.5c13.1-17.7,46.1-59,95.2-99.4c37.4-30.8,76.7-55.1,116.9-72.1c49.6-21.1,100.8-31.1,152.1-29.9l0.6,0l0.6,0c51.3-1.2,102.4,8.9,152.1,29.9c40.2,17,79.5,41.3,116.9,72.1c49.1,40.4,82.1,81.8,95.2,99.4C931.2,612.1,898.2,653.4,849.1,693.8z"/><path d="M716.7,570.6c-15.2-77.3-87.7-126.2-165.3-111.8c-46.1,8.6-82.6,40-100.8,79.9c-23.8,75.1-0.5,114.2-0.5,114.2c25,54.4,83.3,84.9,140.8,79c16.1-1.6,30.9-7.2,43.2-18.2c1.2-1.1,2.5-2.8,2.5-4.2c0.2-21.8,0.1-45.4,0.1-67.2l-2.5,3.9c-0.6,0.8-1.1,1.7-1.7,2.5c-7.6,11.2-18.1,18.4-31.3,21.5c-5.2,1.2-10.6,2.2-15.9,2.9c-52.5,6.4-94.2-35.1-87.8-87.5c5.7-46.6,52.6-79.4,98.5-68.9c38,8.7,64.4,42.2,64.5,81.9c0.1,41.4,0,82.7,0,124.1c0,1.7,0,3.4,0,5.1h58.5c0.1-1.5,0.2-2.8,0.2-4.1c0-42.8,0.1-85.6-0.1-128.4C719,587.1,718.3,578.7,716.7,570.6z"/>';
        //si tablette ou moins width 2.5rem
        if (window.innerWidth <= 768) {
            accessibility.setAttribute("width", "2.5rem");
        }
    });
}

/* Enlever le bouton accessibilité quand le menu mobile est ouvert */

function toggleAccessibilityBtn() {
    const elem__accessibilityWrapper =
        document.querySelector("#pojo-a11y-toolbar");
    const elem__menuMobileBurger = document.querySelector(
        ".elementor-element-7b4eb03 .elementskit-menu-hamburger"
    );
    const elem__accessibilityToggleBtn = document.querySelector(
        ".pojo-a11y-toolbar-toggle"
    );

    function closeAccessibilityClick(event) {
        if (!elem__accessibilityWrapper.contains(event.target)) {
            elem__accessibilityWrapper.classList.remove("pojo-a11y-toolbar-open");
            document.removeEventListener("click", closeAccessibilityClick);
        }
    }

    if (elem__menuMobileBurger) {
        const elem__menuMobileCLose = document.querySelector(
            ".elementor-element-7b4eb03 .elementskit-menu-close"
        );
        if (elem__accessibilityToggleBtn) {
            elem__menuMobileBurger.addEventListener("click", () => {
                elem__accessibilityToggleBtn.classList.toggle("hide");
            });
            elem__menuMobileCLose.addEventListener("click", () => {
                elem__accessibilityToggleBtn.classList.toggle("hide");
            });
        }
    }

    if (elem__accessibilityWrapper && elem__accessibilityToggleBtn) {
        elem__accessibilityToggleBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            document.addEventListener("click", closeAccessibilityClick);
        });
    }
}

/* éviter de casser les positions fixed du site avec echelle de gris */

function fixAccessibilityGrayScale() {
    const elem__grayScaleBtn = document.querySelector(
        ".pojo-a11y-btn-grayscale"
    );
    const elem__resetBtn = document.querySelector(".pojo-a11y-btn-reset");

    if (elem__grayScaleBtn) {
        const elem__body = document.querySelector("body");
        const elem__bodyChild = document.querySelectorAll("body > *");

        elem__grayScaleBtn.addEventListener("click", () => {
            elem__body.classList.toggle("body-accessibility-grayscale");
            elem__bodyChild.forEach((el) => {
                el.classList.toggle("accessibility-grayscale");
            });
        });

        elem__resetBtn.addEventListener("click", () => {
            if (elem__body.classList.contains("body-accessibility-grayscale")) {
                elem__body.classList.remove("body-accessibility-grayscale");
                elem__bodyChild.forEach((el) => {
                    el.classList.remove("accessibility-grayscale");
                });
            }
        });
    }
}

function highContrast() {
    tool.waitForElem(".pojo-a11y-btn-high-contrast").then((r) => {
        r.addEventListener("click", () => {
            event.preventDefault();
            tool.waitForElem(".dialog-close-button").then((closeButton) => {
                setTimeout(() => {
                    const isActive = r.classList.contains("active");
                    closeButton.classList.toggle(
                        "dialog-close-button--high-contrast",
                        isActive
                    );
                    closeButton.id = isActive ? "high-contrast" : "";
                }, 0);
            });
        });
    });
}

function accessibilityBehavior() {
    //Add DataLayer Accessibility button
    const btnAccessibility = document.querySelector(".pojo-a11y-toolbar-toggle");
    const navAccessibility = document.getElementById("pojo-a11y-toolbar");

    btnAccessibility.addEventListener("click", function () {
        if (navAccessibility.classList.contains("pojo-a11y-toolbar-open")) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "accessibility",
            });
        }
    });
}

export {accessibility, toggleAccessibilityBtn, fixAccessibilityGrayScale, highContrast, accessibilityBehavior};